import { getUserFromCookies } from 'contexts/user';
import { v4 as uuid } from 'uuid';
import storage from 'utils/storage';
import { isClientSide } from 'utils/host-config';
import type { Identity } from '@bedrock/analytics';

/** Key for the anonymous ID in localStorage. */
const ANALYTICS_ANONYMOUS_ID_KEY = 'analytics_anonymous_id' as const;

/**
 * Resolves identity for analytics events (user_id and/or anonymous_id).
 *
 * Reads from auth cookies for user_id and from localStorage for anonymous_id,
 * creating and persisting an anonymous id when missing.
 *
 * @returns {@link Identity} with at least one of user_id or anonymous_id, or
 *   `undefined` if called on the server-side.
 */
export function getIdentity(): Identity | undefined {
  if (!isClientSide()) {
    return undefined;
  }
  const user = getUserFromCookies();
  let anonymousId = storage.get(ANALYTICS_ANONYMOUS_ID_KEY) as string | null | undefined;
  if (!anonymousId) {
    anonymousId = uuid();
    storage.set(ANALYTICS_ANONYMOUS_ID_KEY, anonymousId);
  }
  return {
    user_id: user ? String(user.id) : undefined,
    anonymous_id: anonymousId,
  };
}
